import React from 'react';
import Table from '../../components/common/Table';
import { ExerciseSpecificDTO } from '../../services/apiClient';
import { renderBooleanBadge } from '../../utils/displayUtils';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';

interface ExerciseSpecificTableProps {
  data: ExerciseSpecificDTO[];
  handleEdit: (row: ExerciseSpecificDTO) => void;
  handleDelete: (row: ExerciseSpecificDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ExerciseSpecificTable: React.FC<ExerciseSpecificTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },

        {
          label: 'Template',
          key: 'templateId',
          render: (row: ExerciseSpecificDTO) =>
            <span>{row.exerciseTemplate?.title || 'Unknown'}</span>,
        },
        {
          label: 'Compliance Hunt',
          key: 'isComplianceHunt',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isComplianceHunt ?? false, 'Yes', 'No'),
        },
        {
          label: 'Compliance Sport',
          key: 'isComplianceSport',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isComplianceSport ?? false, 'Yes', 'No'),
        },
        {
          label: 'Eval Hunt',
          key: 'isEvaluationHunt',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isEvaluationHunt ?? false, 'Yes', 'No'),
        },
        {
          label: 'Eval Sport',
          key: 'isEvaluationSport',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isEvaluationSport ?? false, 'Yes', 'No'),
        },
        {
          label: 'Competition',
          key: 'isCompetition',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isCompetition ?? false, 'Yes', 'No'),
        },
        {
          label: 'Activity Hunt',
          key: 'isHuntActivity',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isHuntActivity ?? false, 'Yes', 'No'),
        },
        {
          label: 'Activity Sport',
          key: 'isSportShootingActivity',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isSportShootingActivity ?? false, 'Yes', 'No'),
        },
        {
          label: 'Status',
          key: 'isActive',
          render: (row: ExerciseSpecificDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (createdUtc: Date) =>
            convertToUserTime(createdUtc?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ExerciseSpecificTable;
